function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStaircase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    viewBox: "0 0 100 100",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    points: "  90,10 70,10 70,30 50,30 50,50 30,50 30,70 10,70 10,90 90,90 ",
    style: {
      fill: "#FFFFFF",
      stroke: "#000000",
      strokeWidth: 5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaircase);
export default __webpack_public_path__ + "static/media/staircase.512f96690c00e75248da2c54c6f2f4fb.svg";
export { ForwardRef as ReactComponent };